export const reviewData = [
  {
    message: "Fresh and fastest delivery",
    name: "Suraj",
    state: "TamilNadu",
  },
  {
    message: "Friendly service",
    name: "Sanjay",
    state: "TamilNadu",
  },
  {
    message: "Fresh and fastest delivery",
    name: "Swamy",
    state: "TamilNadu",
  },
  {
    message: "Fresh and fastest delivery",
    name: "Suraj",
    state: "TamilNadu",
  },
];
